import React from 'react';
import Icon from './Icon';

const FAQ = (props) => (
  <Icon viewBox="0 0 19 19" {...props}>
    <title>FAQ</title>
    <g id="New-UX" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="My-Account/Rewards" transform="translate(-704.000000, -657.000000)">
        <g id="FAQ-icon" transform="translate(705.000000, 658.000000)">
          <g id="Group" transform="translate(5.666667, 2.833333)">
            <path d="M0.354166667,3.1875 L0.354166667,2.69166447 C0.354166667,1.40070012 1.46412592,0.354166667 2.83333064,0.354166667 L2.83333603,0.354166667 C4.20254075,0.354166667 5.3125,1.40070012 5.3125,2.69166447 L5.3125,3.28177683 C5.3125,3.9017198 5.051303,4.49627135 4.58636944,4.93463746 L3.5594639,5.90286268 C3.09453033,6.34122879 2.83333333,6.93578035 2.83333333,7.55572331 L2.83333333,8.85416667" id="Shape" stroke="#003953" strokeLinecap="round" strokeLinejoin="round"/>
            <circle id="Oval" fill="#003953" fillRule="nonzero" cx="2.83333333" cy="10.6666667" r="1"/>
          </g>
          <circle id="Oval" stroke="#003953" strokeLinecap="round" strokeLinejoin="round" cx="8.5" cy="8.5" r="8.14583333"/>
        </g>
      </g>
    </g>
  </Icon>
);

export default FAQ;
